/**
 * Labstep
 *
 * @module components/User/Settings/LoginSecurity
 * @desc Login Security section
 */

import { UserSettingsLoginSecurityChangePassword } from 'labstep-web/components/User/Settings/LoginSecurity/ChangePassword';
import type React from 'react';

export const UserSettingsLoginSecurity: React.FC = () => (
  <div id="login-security">
    <span>Password</span>
    <UserSettingsLoginSecurityChangePassword />
  </div>
);
